<script setup lang="ts">
  import TheContent from '~/components/content/TheContent';

  const props = defineProps<{
    elem: TContent<{
      steps: TContent[][];
    }>;
  }>();

  const stepsSections = computed(() => props.elem.children);
</script>

<template>
  <section
    v-if="stepsSections.length"
    class="cooking-steps instructions"
  >
    <h2 class="cooking-steps__title">Приготовление</h2>
    <ol class="cooking-steps__list">
      <li
        v-for="(item, index) of stepsSections"
        :key="index"
        class="cooking-steps__item instruction"
      >
        <h3 class="cooking-steps__item-number">Шаг {{ index + 1 }}</h3>
        <div class="cooking-steps__item-content">
          <TheContent
            :key="item.id"
            :elem="item"
          />
        </div>
      </li>
    </ol>
  </section>
</template>

<style lang="scss">
  @mixin fontStepTitleMobile() {
    font-size: 26px;
    font-family: $secondFont;
    font-weight: 600;
    line-height: 34px;
  }

  .cooking-steps {
    background: white;

    img {
      width: 100%;
      height: auto;
    }

    img.border {
      border: solid 1px #ccc;
    }

    &__title {
      @include fontStepTitleMobile;
      padding: 0;

      @include tablet {
        @include fontH2;

        padding: 0;
      }

      @include print {
        font-family: $secondFont;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        // gap 24 + 8 = 32px
        margin-top: 8px;
      }
    }

    &__buttons {
      margin: 0 0 16px;
      border-bottom: 1px solid #e7e7e7;
    }

    &__show-full-button {
      @include fontTextBtn;

      display: inline-block;
      color: #2962f9;
      cursor: pointer;
      border-bottom: 2px solid transparent;
      transition: border-color 0.3s;
      position: relative;
      top: -16px;

      &:hover {
        border-color: #2962f9;
      }
    }

    &__list {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    &__item {
      list-style: none;
      padding: 16px 0 32px;
      margin: 0;

      @include tablet {
        padding-bottom: 40px;
      }
      @include print {
        padding-bottom: 24px;
      }

      & + & {
        border-top: 1px solid #e7e7e7;
      }

      &:not(:first-child) {
      }

      p:not(:last-child) {
        .step-link {
          margin-bottom: 24px;
        }
      }
    }

    &__item-number {
      font-size: 22px;
      line-height: 30px;
      margin-bottom: 12px;
      font-weight: 600;

      @include tablet {
        font-size: 24px;
        line-height: 32px;
      }

      @include print {
        font-family: $secondFont;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
      }
    }

    &__item-content {
      @include fontNormalText(true);

      @include tablet {
        @include fontMediumText;
      }

      figure {
        width: 100%;
        margin-top: 24px;

        &:not(:last-child) {
          margin-bottom: 24px;
        }

        img {
          width: 100%;
          height: auto;
          margin-bottom: 8px;
        }

        figcaption {
          @include fontTinyText;

          color: #5c5c5c;
        }
      }

      p a {
        text-decoration-color: $main;
        color: black;
      }

      p:not(:last-child) {
        margin-bottom: 16px;
      }

      p:empty {
        display: none;
      }

      iframe {
        width: 100%;
      }

      @include print {
        @include fontTinyText;
        color: black;
      }
    }
  }
</style>
